export default "__VITE_ASSET__DFVxjEhu__"